module.exports = __webpack_public_path__ + "static/lightPop-b2f6cda13cedea514bd7032a2e327e39.wav";